import { Box, CircularProgress, Paper } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';

import { useHeader } from '@app/components/common/navigation/hooks/header-service';
import { useAlert, useApi } from '@app/hooks';

import { StandFormInstance } from './types';
import StandForm from './form';

const StandModelEdit: FC = () => {
  useHeader('Изменить стойку', []);
  const params = useParams<{ id: string }>();
  const api = useApi();
  const { error } = useAlert();
  const history = useHistory();

  const [instance, setInstance] = useState<StandFormInstance | undefined>(
    undefined
  );
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (params.id) {
      api.stands.getStands({
        filter: { id: params.id },
        sort: '+id',
        limit: 1,
        offset: 0,
      }).then(({ code, message, data }) => {
        if (code !== 200) {
          error(message);
          return;
        }
        setInstance({
          ...data[0],
        });
        setLoading(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  const onFormSubmit = (instance: Partial<StandFormInstance>) => {
    setLoading(true);
    api.stands
      .updateStand({
        id: instance.id?.toString() || '',
        model_id: instance.model?.id?.toString() || '',
      })
      .then(() => {
        setLoading(false);
        history.push('/equipments-stands/');
      });
  };

  const onFormCancel = () => {
    history.push('/equipments-stands/');
  };

  return (
    <Box paddingX={{ xs: 0, sm: 2, md: 10, lg: 14, xl: 20 }}>
      <Paper>
        <Box paddingX={2} paddingY={3}>
          {(!instance || loading) ? (
            <Box
              width="100%"
              height="300px"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <CircularProgress size={24} />
            </Box>
          ) : (
            <StandForm
              instance={instance}
              onSubmit={onFormSubmit}
              onCancel={onFormCancel}
              submitText="Изменить"
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default StandModelEdit;
